import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { Injectable, inject } from '@angular/core';

import { TranslocoService } from '@jsverse/transloco';
import { ApiService } from '@ng-gems/api';

import { UserAdapter } from '@app/core/adapters/user.adapter';
import { User } from '@models/user.model';

import { LocalStorageService } from './local-storage.service';
import { OktaService } from './okta.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private localStorageService = inject(LocalStorageService);
  private oktaService = inject(OktaService);
  private api = inject(ApiService);
  private translateService = inject(TranslocoService);
  private userAdapter = new UserAdapter();
  /**
   * Store the URL so we can redirect after logging in
   */
  redirectUrl: string;

  private userSubject: BehaviorSubject<User> = new BehaviorSubject<User>(null);

  get user(): User {
    return this.userSubject.value;
  }

  getUser(): Observable<User> {
    return this.userSubject.asObservable();
  }

  resetUser() {
    this.userSubject.next(undefined);
  }

  /**
   * if logged in return true
   * if not logged in then try login, and return true for success, false for fail
   */
  getRemoteUser(emitUpdateLanguage: boolean = true): Observable<User> {
    if (this.user) {
      return this.getUser();
    }
    return this.refreshUser(emitUpdateLanguage);
  }

  logout() {
    this.resetUser();
    this.oktaService.logOut();
  }

  /**
   * Reload user, his/her grants and capacities
   */
  refreshUser(emitUpdateLanguage: boolean = true): Observable<User> {
    return this.api.portalCustomer.getUserProfile().pipe(
      map((it) => this.userAdapter.get(it)),
      tap((user: User) => this.userSubject.next(user)),
      tap((user: User) => (this.localStorageService.lang = user.lang)),
      tap((user: User) => {
        if (emitUpdateLanguage) this.translateService.setActiveLang(user.lang);
      }),
    );
  }
}
